import type { BpmnGenerationOptions } from '@/client/types.gen'

export type BpmnGenerationOptionsState = Required<BpmnGenerationOptions>

export const DEFAULT_BPMN_GENERATION_OPTIONS: BpmnGenerationOptionsState = {
	include_intermediate_events: false,
	include_exception_highlights: false,
	include_bottleneck_highlights: false,
	include_exception_annotations: false,
	include_risk_annotations: false,
	include_control_annotations: false,
}

export type BpmnGenerationOptionKey = keyof BpmnGenerationOptionsState

export const BPMN_OPTION_GROUPS: {
	groupKey: 'process' | 'annotations'
	optionKeys: BpmnGenerationOptionKey[]
}[] = [
	{
		groupKey: 'process',
		optionKeys: ['include_intermediate_events'],
	},
	{
		groupKey: 'annotations',
		optionKeys: [
			'include_exception_annotations',
			'include_risk_annotations',
			'include_control_annotations',
		],
	},
]

const HIDDEN_BPMN_OPTION_KEYS = new Set<BpmnGenerationOptionKey>([
	'include_exception_highlights',
	'include_bottleneck_highlights',
])

export function countEnabledBpmnOptions(options: BpmnGenerationOptionsState): number {
	return listEnabledBpmnOptionKeys(options).length
}

export function listEnabledBpmnOptionKeys(
	options: BpmnGenerationOptionsState
): BpmnGenerationOptionKey[] {
	return (Object.entries(options) as [BpmnGenerationOptionKey, boolean][])
		.filter(([key, enabled]) => enabled && !HIDDEN_BPMN_OPTION_KEYS.has(key))
		.map(([key]) => key)
}

export function normalizeBpmnGenerationOptions(
	options?: BpmnGenerationOptions | null
): BpmnGenerationOptionsState {
	return {
		...DEFAULT_BPMN_GENERATION_OPTIONS,
		...options,
	}
}
